import { render, staticRenderFns } from "./contact-show.vue?vue&type=template&id=36c8986d&scoped=true&"
import script from "./contact-show.ts?vue&type=script&lang=ts&"
export * from "./contact-show.ts?vue&type=script&lang=ts&"
import style0 from "./contact-show.scss?vue&type=style&index=0&id=36c8986d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36c8986d",
  null
  
)

export default component.exports